var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.49992V5.83325H16.6667V7.49992H15V9.16658H16.6667V10.8333H18.3333V9.16658H20V7.49992H18.3333Z",
    fill: "#079455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.99992C8.50833 9.99992 10 8.50825 10 6.66659C10 4.82492 8.50833 3.33325 6.66667 3.33325C4.825 3.33325 3.33333 4.82492 3.33333 6.66659C3.33333 8.50825 4.825 9.99992 6.66667 9.99992ZM6.66667 4.99992C7.58333 4.99992 8.33333 5.74992 8.33333 6.66659C8.33333 7.58325 7.58333 8.33325 6.66667 8.33325C5.75 8.33325 5 7.58325 5 6.66659C5 5.74992 5.75 4.99992 6.66667 4.99992Z",
    fill: "#079455"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.8333C4.44167 10.8333 0 11.9499 0 14.1666V16.6666H13.3333V14.1666C13.3333 11.9499 8.89167 10.8333 6.66667 10.8333ZM11.6667 14.9999H1.66667V14.1749C1.83333 13.5749 4.41667 12.4999 6.66667 12.4999C8.91667 12.4999 11.5 13.5749 11.6667 14.1666V14.9999Z",
    fill: "#079455"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.425 3.37492C11.1917 4.25825 11.6667 5.40825 11.6667 6.66659C11.6667 7.92492 11.1917 9.07492 10.425 9.95825C12.0583 9.74992 13.3333 8.36659 13.3333 6.66659C13.3333 4.96659 12.0583 3.58325 10.425 3.37492Z",
    fill: "#079455"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.775 11.5249C14.5167 12.2166 15 13.0833 15 14.1666V16.6666H16.6667V14.1666C16.6667 12.9583 15.3417 12.0749 13.775 11.5249Z",
    fill: "#079455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupAdd);
export default __webpack_public_path__ + "static/media/group-add.38494b39fbabff9c41950f1980224071.svg";
export { ForwardRef as ReactComponent };